/**
 * Rillion Prime API v1.0
 * A REST API endpoint for System operations.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type HeadersOnly = 0 | 1;

export const HeadersOnly = {
  NUMBER_0: 0 as HeadersOnly,
  NUMBER_1: 1 as HeadersOnly,
};
